import './footer.css'

const footerLinks = [
    {
        href: 'https://factur247.com/politicas_de_privacidad',
        label: 'Políticas de Privacidad',
    },
    {
        href: 'https://factur247.com/derechos-arco/',
        label: 'Derechos ARCO',
    },
    {
        href: 'https://factur247.com/terminos_y_condiciones/',
        label: 'Términos y Condiciones',
    },
]

export default function Footer() {
    return (
        <footer className="site-footer">
            <div className="footer-divider" aria-hidden="true" />

            <div className="footer-content">
                <div className="footer-actions">
                    <a
                        className="footer-chip footer-chip--whatsapp"
                        href="https://api.whatsapp.com/send?phone=593961693331"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {/* WhatsApp SVG */}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 32 32"
                            width="18"
                            height="18"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path d="M16 0C7.163 0 0 7.163 0 16c0 2.823.735 5.478 2.018 7.786L.047 32l8.425-2.21A15.937 15.937 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm8.264 22.533c-.343.962-2.004 1.841-2.767 1.954-.709.105-1.604.148-2.588-.161-.598-.189-1.365-.44-2.348-.863-4.129-1.785-6.824-5.944-7.03-6.222-.207-.277-1.683-2.238-1.683-4.267s1.064-3.022 1.442-3.44c.377-.419.824-.523 1.098-.523.273 0 .547.003.787.014.252.012.59-.096.923.703.344.824 1.166 2.848 1.268 3.056.103.208.172.45.034.726-.137.277-.206.45-.41.692-.205.243-.43.542-.615.727-.205.205-.417.427-.179.838.238.41 1.057 1.744 2.27 2.826 1.56 1.39 2.876 1.82 3.287 2.025.41.205.649.172.888-.103.238-.274 1.024-1.196 1.297-1.607.273-.41.547-.343.923-.206.377.137 2.393 1.128 2.803 1.334.41.205.683.308.785.48.103.172.103 1.0 0 1.962-.343.962-.343.962-.343.962z" />
                        </svg>
                        WhatsApp
                    </a>

                    <a
                        className="footer-chip footer-chip--developer"
                        href="https://tudesarrollador.com/cv"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {/* Code / developer icon */}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <polyline points="16 18 22 12 16 6" />
                            <polyline points="8 6 2 12 8 18" />
                        </svg>
                        Desarrollador
                    </a>
                </div>

                <nav className="footer-links" aria-label="Enlaces legales">
                    {footerLinks.map((link) => (
                        <a
                            key={link.href}
                            href={link.href}
                            className="footer-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-external
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>

                <p className="footer-legal">
                    Todos los derechos de la página web pertenecen a factur247.com
                </p>
            </div>
        </footer>
    )
}
